export enum EMapId {
  CM_3V3_TUTORIAL = 'cm_3v3_tutorial',
  /** Persisted id. Preferred name: `cm_3v3_sp` (solo coop vs AI). Rename only with match-history DB migration. */
  CM_3V3_COOP = 'cm_3v3_coop',
  /** Preferred name: `cm_3v3_coop` (MP coop). Rename only with match-history DB migration if this id is ever persisted. */
  CM_3V3_COOP_MP = 'cm_3v3_coop_mp',
  CM_3V3_PVP = 'cm_3v3_pvp'
}

export enum TutorialIdEnum {
  EDIT_BOTS_TUTORIAL = 'edit_bots_tutorial'
}

export enum UserFlagsEnum {
  BOT_INTRO_DONE = 'bot_intro_done',
  TR_MAPS_COMPLETED = 'tr_maps_completed',
  CM_3V3_COOP_UNLOCKED = 'cm_3v3_coop_unlocked',
  CM_3V3_PVP_UNLOCKED = 'cm_3v3_pvp_unlocked',
  LAST_OPENING_CUTSCENE_DAY = 'last_opening_cutscene_day',
  LAST_CELEBRATION_CUTSCENE_DAY = 'last_celebration_cutscene_day',
  EDIT_BOTS_TUTORIAL_DONE = 'edit_bots_tutorial_done'
}

export enum UserFlagValuesEnum {
  UNLOCKED = 'unlocked'
}

export interface IUserFlag {
  flagName: UserFlagsEnum;
  flagValue: string;
}

export type IUserFlags = { [k in string]: string };

export enum EBoostItemId {
  BOOST_ARMOR_MECHANICAL = 'item_boost_armormechanical',
  BOOST_ARMOR_MECHANICAL_2 = 'item_boost_armormechanical_2',
  BOOST_ARMOR_MECHANICAL_3 = 'item_boost_armormechanical_3',
  BOOST_ARMOR_ELECTRICAL = 'item_boost_armorelectrical',
  BOOST_ARMOR_ELECTRICAL_2 = 'item_boost_armorelectrical_2',
  BOOST_ARMOR_ELECTRICAL_3 = 'item_boost_armorelectrical_3',
  BOOST_HEALTH = 'item_boost_health',
  BOOST_HEALTH_2 = 'item_boost_health_2',
  BOOST_HEALTH_3 = 'item_boost_health_3',
  BOOST_MOVESPEED = 'item_boost_movespeed',
  BOOST_MOVESPEED_2 = 'item_boost_movespeed_2',
  BOOST_MOVESPEED_3 = 'item_boost_movespeed_3',
  BOOST_POWER_ELECTRICAL = 'item_boost_powerelectrical',
  BOOST_POWER_ELECTRICAL_2 = 'item_boost_powerelectrical_2',
  BOOST_POWER_ELECTRICAL_3 = 'item_boost_powerelectrical_3',
  BOOST_POWER_MECHANICAL = 'item_boost_powermechanical',
  BOOST_POWER_MECHANICAL_2 = 'item_boost_powermechanical_2',
  BOOST_POWER_MECHANICAL_3 = 'item_boost_powermechanical_3',
  BOOST_REBOOT = 'item_boost_reboot',
  BOOST_REBOOT_2 = 'item_boost_reboot_2',
  BOOST_REBOOT_3 = 'item_boost_reboot_3',
  BOOST_ALL_AROUNDER = 'item_boost_allarounder',
  BOOST_ALL_AROUNDER_2 = 'item_boost_allarounder_2',
  BOOST_ALL_AROUNDER_3 = 'item_boost_allarounder_3'
}

export enum ERoleHatItemId {
  HAT_DEFAULT = 'item_hat_default',
  HAT_HEALER_BOUNCEBACK = 'item_hat_healer_bounceback',
  HAT_SWAPPER_TRIPLETHREAT = 'item_hat_swapper_triplethreat',
  HAT_PUSHER_SUPERSOAK = 'item_hat_pusher_supersoak',
  HAT_CARRY_DOUBLETIME = 'item_hat_carry_doubletime',
  HAT_TANK_SELFDEFENSE = 'item_hat_tank_selfdefense'
}
export const isRoleHatItemId = (key: string): key is ERoleHatItemId => {
  const stringValues = Object.values(ERoleHatItemId) as string[];
  return stringValues.includes(key);
};

export enum ECurrencyItemId {
  CURRENCY_PARTS = 'item_currency_parts',
  CURRENCY_PREMIUM = 'item_currency_premium',
  CURRENCY_QUESTIONS = 'item_currency_questions'
}

/**
 * Zogear "parts" (helmet, platform, rudder, treads) for each animal.
 */
export enum EPartItemId {
  PART_DOG_DEFAULT_HELMET = 'item_part_dog_default_helmet',
  PART_DOG_DEFAULT_PLATFORM = 'item_part_dog_default_platform',
  PART_DOG_DEFAULT_RUDDER = 'item_part_dog_default_rudder',
  PART_DOG_DEFAULT_TREADS = 'item_part_dog_default_treads',

  PART_DOG_DEFAULT_V2_HELMET = 'item_part_dog_default_v2_helmet',
  PART_DOG_DEFAULT_V2_PLATFORM = 'item_part_dog_default_v2_platform',
  PART_DOG_DEFAULT_V2_RUDDER = 'item_part_dog_default_v2_rudder',
  PART_DOG_DEFAULT_V2_TREADS = 'item_part_dog_default_v2_treads',

  PART_DOG_BEACH_V1_PLATFORM = 'item_part_dog_beach_v1_platform',
  PART_DOG_BEACH_V1_HELMET = 'item_part_dog_beach_v1_helmet',
  PART_DOG_BEACH_V1_RUDDER = 'item_part_dog_beach_v1_rudder',
  PART_DOG_BEACH_V1_TREADS = 'item_part_dog_beach_v1_treads',

  PART_DOG_BEACH_V2_PLATFORM = 'item_part_dog_beach_v2_platform',
  PART_DOG_BEACH_V2_HELMET = 'item_part_dog_beach_v2_helmet',
  PART_DOG_BEACH_V2_RUDDER = 'item_part_dog_beach_v2_rudder',
  PART_DOG_BEACH_V2_TREADS = 'item_part_dog_beach_v2_treads',

  PART_DOG_GUARDIAN_REWARD_V1_PLATFORM = 'item_part_dog_guardian_reward_v1_platform',
  PART_DOG_GUARDIAN_REWARD_V1_HELMET = 'item_part_dog_guardian_reward_v1_helmet',
  PART_DOG_GUARDIAN_REWARD_V1_RUDDER = 'item_part_dog_guardian_reward_v1_rudder',
  PART_DOG_GUARDIAN_REWARD_V1_TREADS = 'item_part_dog_guardian_reward_v1_treads',

  PART_DOG_GUARDIAN_REWARD_V2_PLATFORM = 'item_part_dog_guardian_reward_v2_platform',
  PART_DOG_GUARDIAN_REWARD_V2_HELMET = 'item_part_dog_guardian_reward_v2_helmet',
  PART_DOG_GUARDIAN_REWARD_V2_RUDDER = 'item_part_dog_guardian_reward_v2_rudder',
  PART_DOG_GUARDIAN_REWARD_V2_TREADS = 'item_part_dog_guardian_reward_v2_treads',

  PART_DOG_HOOD_V1_PLATFORM = 'item_part_dog_hood_v1_platform',
  PART_DOG_SCOUTER_V1_HELMET = 'item_part_dog_scouter_v1_helmet',
  PART_DOG_SCARF_V1_RUDDER = 'item_part_dog_scarf_v1_rudder',
  PART_DOG_ARMOR_V1_TREADS = 'item_part_dog_armor_v1_treads',

  PART_DOG_HOOD_V2_PLATFORM = 'item_part_dog_hood_v2_platform',
  PART_DOG_SCOUTER_V2_HELMET = 'item_part_dog_scouter_v2_helmet',
  PART_DOG_SCARF_V2_RUDDER = 'item_part_dog_scarf_v2_rudder',
  PART_DOG_ARMOR_V2_TREADS = 'item_part_dog_armor_v2_treads',

  PART_CAT_DEFAULT_HELMET = 'item_part_cat_default_helmet',
  PART_CAT_DEFAULT_PLATFORM = 'item_part_cat_default_platform',
  PART_CAT_DEFAULT_RUDDER = 'item_part_cat_default_rudder',
  PART_CAT_DEFAULT_TREADS = 'item_part_cat_default_treads',

  PART_CAT_DEFAULT_V2_HELMET = 'item_part_cat_default_v2_helmet',
  PART_CAT_DEFAULT_V2_PLATFORM = 'item_part_cat_default_v2_platform',
  PART_CAT_DEFAULT_V2_RUDDER = 'item_part_cat_default_v2_rudder',
  PART_CAT_DEFAULT_V2_TREADS = 'item_part_cat_default_v2_treads',

  PART_CAT_BEACH_V1_PLATFORM = 'item_part_cat_beach_v1_platform',
  PART_CAT_BEACH_V1_HELMET = 'item_part_cat_beach_v1_helmet',
  PART_CAT_BEACH_V1_RUDDER = 'item_part_cat_beach_v1_rudder',
  PART_CAT_BEACH_V1_TREADS = 'item_part_cat_beach_v1_treads',

  PART_CAT_BEACH_V2_PLATFORM = 'item_part_cat_beach_v2_platform',
  PART_CAT_BEACH_V2_HELMET = 'item_part_cat_beach_v2_helmet',
  PART_CAT_BEACH_V2_RUDDER = 'item_part_cat_beach_v2_rudder',
  PART_CAT_BEACH_V2_TREADS = 'item_part_cat_beach_v2_treads',

  PART_CAT_GUARDIAN_REWARD_V1_PLATFORM = 'item_part_cat_guardian_reward_v1_platform',
  PART_CAT_GUARDIAN_REWARD_V1_HELMET = 'item_part_cat_guardian_reward_v1_helmet',
  PART_CAT_GUARDIAN_REWARD_V1_RUDDER = 'item_part_cat_guardian_reward_v1_rudder',
  PART_CAT_GUARDIAN_REWARD_V1_TREADS = 'item_part_cat_guardian_reward_v1_treads',

  PART_CAT_GUARDIAN_REWARD_V2_PLATFORM = 'item_part_cat_guardian_reward_v2_platform',
  PART_CAT_GUARDIAN_REWARD_V2_HELMET = 'item_part_cat_guardian_reward_v2_helmet',
  PART_CAT_GUARDIAN_REWARD_V2_RUDDER = 'item_part_cat_guardian_reward_v2_rudder',
  PART_CAT_GUARDIAN_REWARD_V2_TREADS = 'item_part_cat_guardian_reward_v2_treads',

  PART_CAT_HOOD_V1_PLATFORM = 'item_part_cat_hood_v1_platform',
  PART_CAT_SCOUTER_V1_HELMET = 'item_part_cat_scouter_v1_helmet',
  PART_CAT_SCARF_V1_RUDDER = 'item_part_cat_scarf_v1_rudder',
  PART_CAT_ARMOR_V1_TREADS = 'item_part_cat_armor_v1_treads',

  PART_CAT_HOOD_V2_PLATFORM = 'item_part_cat_hood_v2_platform',
  PART_CAT_SCOUTER_V2_HELMET = 'item_part_cat_scouter_v2_helmet',
  PART_CAT_SCARF_V2_RUDDER = 'item_part_cat_scarf_v2_rudder',
  PART_CAT_ARMOR_V2_TREADS = 'item_part_cat_armor_v2_treads',

  PART_PIG_DEFAULT_HELMET = 'item_part_pig_default_helmet',
  PART_PIG_DEFAULT_PLATFORM = 'item_part_pig_default_platform',
  PART_PIG_DEFAULT_RUDDER = 'item_part_pig_default_rudder',
  PART_PIG_DEFAULT_TREADS = 'item_part_pig_default_treads',

  PART_PIG_DEFAULT_V2_HELMET = 'item_part_pig_default_v2_helmet',
  PART_PIG_DEFAULT_V2_PLATFORM = 'item_part_pig_default_v2_platform',
  PART_PIG_DEFAULT_V2_RUDDER = 'item_part_pig_default_v2_rudder',
  PART_PIG_DEFAULT_V2_TREADS = 'item_part_pig_default_v2_treads',

  PART_PIG_HOOD_V1_PLATFORM = 'item_part_pig_hood_v1_platform',
  PART_PIG_SCOUTER_V1_HELMET = 'item_part_pig_scouter_v1_helmet',
  PART_PIG_SCARF_V1_RUDDER = 'item_part_pig_scarf_v1_rudder',
  PART_PIG_ARMOR_V1_TREADS = 'item_part_pig_armor_v1_treads',

  PART_PIG_HOOD_V2_PLATFORM = 'item_part_pig_hood_v2_platform',
  PART_PIG_SCOUTER_V2_HELMET = 'item_part_pig_scouter_v2_helmet',
  PART_PIG_SCARF_V2_RUDDER = 'item_part_pig_scarf_v2_rudder',
  PART_PIG_ARMOR_V2_TREADS = 'item_part_pig_armor_v2_treads',

  PART_HORSE_DEFAULT_HELMET = 'item_part_horse_default_helmet',
  PART_HORSE_DEFAULT_PLATFORM = 'item_part_horse_default_platform',
  PART_HORSE_DEFAULT_RUDDER = 'item_part_horse_default_rudder',
  PART_HORSE_DEFAULT_TREADS = 'item_part_horse_default_treads',

  PART_HORSE_DEFAULT_V2_HELMET = 'item_part_horse_default_v2_helmet',
  PART_HORSE_DEFAULT_V2_PLATFORM = 'item_part_horse_default_v2_platform',
  PART_HORSE_DEFAULT_V2_RUDDER = 'item_part_horse_default_v2_rudder',
  PART_HORSE_DEFAULT_V2_TREADS = 'item_part_horse_default_v2_treads',

  PART_HORSE_HOOD_V1_PLATFORM = 'item_part_horse_hood_v1_platform',
  PART_HORSE_SCOUTER_V1_HELMET = 'item_part_horse_scouter_v1_helmet',
  PART_HORSE_SCARF_V1_RUDDER = 'item_part_horse_scarf_v1_rudder',
  PART_HORSE_ARMOR_V1_TREADS = 'item_part_horse_armor_v1_treads',

  PART_HORSE_HOOD_V2_PLATFORM = 'item_part_horse_hood_v2_platform',
  PART_HORSE_SCOUTER_V2_HELMET = 'item_part_horse_scouter_v2_helmet',
  PART_HORSE_SCARF_V2_RUDDER = 'item_part_horse_scarf_v2_rudder',
  PART_HORSE_ARMOR_V2_TREADS = 'item_part_horse_armor_v2_treads',

  PART_SHEEP_DEFAULT_HELMET = 'item_part_sheep_default_helmet',
  PART_SHEEP_DEFAULT_PLATFORM = 'item_part_sheep_default_platform',
  PART_SHEEP_DEFAULT_RUDDER = 'item_part_sheep_default_rudder',
  PART_SHEEP_DEFAULT_TREADS = 'item_part_sheep_default_treads',

  PART_SHEEP_DEFAULT_V2_HELMET = 'item_part_sheep_default_v2_helmet',
  PART_SHEEP_DEFAULT_V2_PLATFORM = 'item_part_sheep_default_v2_platform',
  PART_SHEEP_DEFAULT_V2_RUDDER = 'item_part_sheep_default_v2_rudder',
  PART_SHEEP_DEFAULT_V2_TREADS = 'item_part_sheep_default_v2_treads',

  PART_SHEEP_HOOD_V1_PLATFORM = 'item_part_sheep_hood_v1_platform',
  PART_SHEEP_SCOUTER_V1_HELMET = 'item_part_sheep_scouter_v1_helmet',
  PART_SHEEP_SCARF_V1_RUDDER = 'item_part_sheep_scarf_v1_rudder',
  PART_SHEEP_ARMOR_V1_TREADS = 'item_part_sheep_armor_v1_treads',

  PART_SHEEP_HOOD_V2_PLATFORM = 'item_part_sheep_hood_v2_platform',
  PART_SHEEP_SCOUTER_V2_HELMET = 'item_part_sheep_scouter_v2_helmet',
  PART_SHEEP_SCARF_V2_RUDDER = 'item_part_sheep_scarf_v2_rudder',
  PART_SHEEP_ARMOR_V2_TREADS = 'item_part_sheep_armor_v2_treads',

  PART_CAT_APPLEBOOK_V1_HELMET = 'item_part_cat_applebook_v1_helmet',
  PART_DOG_APPLEBOOK_V1_HELMET = 'item_part_dog_applebook_v1_helmet',
  PART_PIG_APPLEBOOK_V1_HELMET = 'item_part_pig_applebook_v1_helmet',
  PART_HORSE_APPLEBOOK_V1_HELMET = 'item_part_horse_applebook_v1_helmet',
  PART_SHEEP_APPLEBOOK_V1_HELMET = 'item_part_sheep_applebook_v1_helmet',

  PART_CAT_CRAYONHEAD_V2_HELMET = 'item_part_cat_crayonhead_v2_helmet',
  PART_DOG_CRAYONHEAD_V2_HELMET = 'item_part_dog_crayonhead_v2_helmet',
  PART_PIG_CRAYONHEAD_V2_HELMET = 'item_part_pig_crayonhead_v2_helmet',
  PART_HORSE_CRAYONHEAD_V2_HELMET = 'item_part_horse_crayonhead_v2_helmet',
  PART_SHEEP_CRAYONHEAD_V2_HELMET = 'item_part_sheep_crayonhead_v2_helmet',

  PART_CAT_SCHOOLBUS_V1_HELMET = 'item_part_cat_schoolbus_v1_helmet',
  PART_DOG_SCHOOLBUS_V1_HELMET = 'item_part_dog_schoolbus_v1_helmet',
  PART_PIG_SCHOOLBUS_V1_HELMET = 'item_part_pig_schoolbus_v1_helmet',
  PART_HORSE_SCHOOLBUS_V1_HELMET = 'item_part_horse_schoolbus_v1_helmet',
  PART_SHEEP_SCHOOLBUS_V1_HELMET = 'item_part_sheep_schoolbus_v1_helmet',

  PART_CAT_SCHOOLBUS_V2_HELMET = 'item_part_cat_schoolbus_v2_helmet',
  PART_DOG_SCHOOLBUS_V2_HELMET = 'item_part_dog_schoolbus_v2_helmet',
  PART_PIG_SCHOOLBUS_V2_HELMET = 'item_part_pig_schoolbus_v2_helmet',
  PART_HORSE_SCHOOLBUS_V2_HELMET = 'item_part_horse_schoolbus_v2_helmet',
  PART_SHEEP_SCHOOLBUS_V2_HELMET = 'item_part_sheep_schoolbus_v2_helmet',

  PART_CAT_JACK_ZO_LANTERN_V1_PLATFORM = 'item_part_cat_jack_zo_lantern_v1_platform',
  PART_CAT_JACK_ZO_LANTERN_V1_HELMET = 'item_part_cat_jack_zo_lantern_v1_helmet',
  PART_CAT_JACK_ZO_LANTERN_V1_TREADS = 'item_part_cat_jack_zo_lantern_v1_treads',
  PART_CAT_JACK_ZO_LANTERN_V1_RUDDER = 'item_part_cat_jack_zo_lantern_v1_rudder',

  PART_CAT_JACK_ZO_LANTERN_V2_PLATFORM = 'item_part_cat_jack_zo_lantern_v2_platform',
  PART_CAT_JACK_ZO_LANTERN_V2_HELMET = 'item_part_cat_jack_zo_lantern_v2_helmet',
  PART_CAT_JACK_ZO_LANTERN_V2_TREADS = 'item_part_cat_jack_zo_lantern_v2_treads',
  PART_CAT_JACK_ZO_LANTERN_V2_RUDDER = 'item_part_cat_jack_zo_lantern_v2_rudder',

  PART_DOG_JACK_ZO_LANTERN_V1_PLATFORM = 'item_part_dog_jack_zo_lantern_v1_platform',
  PART_DOG_JACK_ZO_LANTERN_V1_HELMET = 'item_part_dog_jack_zo_lantern_v1_helmet',
  PART_DOG_JACK_ZO_LANTERN_V1_TREADS = 'item_part_dog_jack_zo_lantern_v1_treads',
  PART_DOG_JACK_ZO_LANTERN_V1_RUDDER = 'item_part_dog_jack_zo_lantern_v1_rudder',

  PART_DOG_JACK_ZO_LANTERN_V2_PLATFORM = 'item_part_dog_jack_zo_lantern_v2_platform',
  PART_DOG_JACK_ZO_LANTERN_V2_HELMET = 'item_part_dog_jack_zo_lantern_v2_helmet',
  PART_DOG_JACK_ZO_LANTERN_V2_TREADS = 'item_part_dog_jack_zo_lantern_v2_treads',
  PART_DOG_JACK_ZO_LANTERN_V2_RUDDER = 'item_part_dog_jack_zo_lantern_v2_rudder',

  PART_CAT_SNOW_GLOW_V1_PLATFORM = 'item_part_cat_snowglow_v1_platform',
  PART_CAT_SNOW_GLOW_V1_HELMET = 'item_part_cat_snowglow_v1_helmet',
  PART_CAT_SNOW_GLOW_V1_TREADS = 'item_part_cat_snowglow_v1_treads',
  PART_CAT_SNOW_GLOW_V1_RUDDER = 'item_part_cat_snowglow_v1_rudder',

  PART_CAT_SNOW_GLOW_V2_PLATFORM = 'item_part_cat_snowglow_v2_platform',
  PART_CAT_SNOW_GLOW_V2_HELMET = 'item_part_cat_snowglow_v2_helmet',
  PART_CAT_SNOW_GLOW_V2_TREADS = 'item_part_cat_snowglow_v2_treads',
  PART_CAT_SNOW_GLOW_V2_RUDDER = 'item_part_cat_snowglow_v2_rudder',

  PART_DOG_SNOW_GLOW_V1_PLATFORM = 'item_part_dog_snowglow_v1_platform',
  PART_DOG_SNOW_GLOW_V1_HELMET = 'item_part_dog_snowglow_v1_helmet',
  PART_DOG_SNOW_GLOW_V1_TREADS = 'item_part_dog_snowglow_v1_treads',
  PART_DOG_SNOW_GLOW_V1_RUDDER = 'item_part_dog_snowglow_v1_rudder',

  PART_DOG_SNOW_GLOW_V2_PLATFORM = 'item_part_dog_snowglow_v2_platform',
  PART_DOG_SNOW_GLOW_V2_HELMET = 'item_part_dog_snowglow_v2_helmet',
  PART_DOG_SNOW_GLOW_V2_TREADS = 'item_part_dog_snowglow_v2_treads',
  PART_DOG_SNOW_GLOW_V2_RUDDER = 'item_part_dog_snowglow_v2_rudder',

  PART_HORSE_SNOW_GLOW_V1_PLATFORM = 'item_part_horse_snowglow_v1_platform',
  PART_HORSE_SNOW_GLOW_V1_HELMET = 'item_part_horse_snowglow_v1_helmet',
  PART_HORSE_SNOW_GLOW_V1_TREADS = 'item_part_horse_snowglow_v1_treads',
  PART_HORSE_SNOW_GLOW_V1_RUDDER = 'item_part_horse_snowglow_v1_rudder',

  PART_HORSE_SNOW_GLOW_V2_PLATFORM = 'item_part_horse_snowglow_v2_platform',
  PART_HORSE_SNOW_GLOW_V2_HELMET = 'item_part_horse_snowglow_v2_helmet',
  PART_HORSE_SNOW_GLOW_V2_TREADS = 'item_part_horse_snowglow_v2_treads',
  PART_HORSE_SNOW_GLOW_V2_RUDDER = 'item_part_horse_snowglow_v2_rudder',

  PART_CAT_SOCCER_STARS_V1_PLATFORM = 'item_part_cat_soccer_stars_v1_platform',
  PART_CAT_SOCCER_STARS_V1_HELMET = 'item_part_cat_soccer_stars_v1_helmet',
  PART_CAT_SOCCER_STARS_V1_TREADS = 'item_part_cat_soccer_stars_v1_treads',
  PART_CAT_SOCCER_STARS_V1_RUDDER = 'item_part_cat_soccer_stars_v1_rudder',

  PART_CAT_SOCCER_STARS_V2_PLATFORM = 'item_part_cat_soccer_stars_v2_platform',
  PART_CAT_SOCCER_STARS_V2_HELMET = 'item_part_cat_soccer_stars_v2_helmet',
  PART_CAT_SOCCER_STARS_V2_TREADS = 'item_part_cat_soccer_stars_v2_treads',
  PART_CAT_SOCCER_STARS_V2_RUDDER = 'item_part_cat_soccer_stars_v2_rudder',

  PART_DOG_SOCCER_STARS_V1_PLATFORM = 'item_part_dog_soccer_stars_v1_platform',
  PART_DOG_SOCCER_STARS_V1_HELMET = 'item_part_dog_soccer_stars_v1_helmet',
  PART_DOG_SOCCER_STARS_V1_TREADS = 'item_part_dog_soccer_stars_v1_treads',
  PART_DOG_SOCCER_STARS_V1_RUDDER = 'item_part_dog_soccer_stars_v1_rudder',

  PART_DOG_SOCCER_STARS_V2_PLATFORM = 'item_part_dog_soccer_stars_v2_platform',
  PART_DOG_SOCCER_STARS_V2_HELMET = 'item_part_dog_soccer_stars_v2_helmet',
  PART_DOG_SOCCER_STARS_V2_TREADS = 'item_part_dog_soccer_stars_v2_treads',
  PART_DOG_SOCCER_STARS_V2_RUDDER = 'item_part_dog_soccer_stars_v2_rudder',

  PART_PIG_SOCCER_STARS_V1_PLATFORM = 'item_part_pig_soccer_stars_v1_platform',
  PART_PIG_SOCCER_STARS_V1_HELMET = 'item_part_pig_soccer_stars_v1_helmet',
  PART_PIG_SOCCER_STARS_V1_TREADS = 'item_part_pig_soccer_stars_v1_treads',
  PART_PIG_SOCCER_STARS_V1_RUDDER = 'item_part_pig_soccer_stars_v1_rudder',

  PART_PIG_SOCCER_STARS_V2_PLATFORM = 'item_part_pig_soccer_stars_v2_platform',
  PART_PIG_SOCCER_STARS_V2_HELMET = 'item_part_pig_soccer_stars_v2_helmet',
  PART_PIG_SOCCER_STARS_V2_TREADS = 'item_part_pig_soccer_stars_v2_treads',
  PART_PIG_SOCCER_STARS_V2_RUDDER = 'item_part_pig_soccer_stars_v2_rudder',

  PART_HORSE_SOCCER_STARS_V1_PLATFORM = 'item_part_horse_soccer_stars_v1_platform',
  PART_HORSE_SOCCER_STARS_V1_HELMET = 'item_part_horse_soccer_stars_v1_helmet',
  PART_HORSE_SOCCER_STARS_V1_TREADS = 'item_part_horse_soccer_stars_v1_treads',
  PART_HORSE_SOCCER_STARS_V1_RUDDER = 'item_part_horse_soccer_stars_v1_rudder',

  PART_HORSE_SOCCER_STARS_V2_PLATFORM = 'item_part_horse_soccer_stars_v2_platform',
  PART_HORSE_SOCCER_STARS_V2_HELMET = 'item_part_horse_soccer_stars_v2_helmet',
  PART_HORSE_SOCCER_STARS_V2_TREADS = 'item_part_horse_soccer_stars_v2_treads',
  PART_HORSE_SOCCER_STARS_V2_RUDDER = 'item_part_horse_soccer_stars_v2_rudder',

  PART_SHEEP_SOCCER_STARS_V1_PLATFORM = 'item_part_sheep_soccer_stars_v1_platform',
  PART_SHEEP_SOCCER_STARS_V1_HELMET = 'item_part_sheep_soccer_stars_v1_helmet',
  PART_SHEEP_SOCCER_STARS_V1_TREADS = 'item_part_sheep_soccer_stars_v1_treads',
  PART_SHEEP_SOCCER_STARS_V1_RUDDER = 'item_part_sheep_soccer_stars_v1_rudder',

  PART_SHEEP_SOCCER_STARS_V2_PLATFORM = 'item_part_sheep_soccer_stars_v2_platform',
  PART_SHEEP_SOCCER_STARS_V2_HELMET = 'item_part_sheep_soccer_stars_v2_helmet',
  PART_SHEEP_SOCCER_STARS_V2_TREADS = 'item_part_sheep_soccer_stars_v2_treads',
  PART_SHEEP_SOCCER_STARS_V2_RUDDER = 'item_part_sheep_soccer_stars_v2_rudder',

  PART_CAT_PUFFYVEST_V1_PLATFORM = 'item_part_cat_puffyvest_v1_platform',
  PART_CAT_PUFFYVEST_V2_PLATFORM = 'item_part_cat_puffyvest_v2_platform',
  PART_CAT_BAKERSHAT_V1_HELMET = 'item_part_cat_bakershat_v1_helmet',
  PART_CAT_BAKERSHAT_V2_HELMET = 'item_part_cat_bakershat_v2_helmet',
  PART_CAT_SCRUNCHIE_V1_TREADS = 'item_part_cat_scrunchie_v1_treads',
  PART_CAT_SCRUNCHIE_V2_TREADS = 'item_part_cat_scrunchie_v2_treads',
  PART_CAT_BRACELET_V1_RUDDER = 'item_part_cat_bracelet_v1_rudder',
  PART_CAT_BRACELET_V2_RUDDER = 'item_part_cat_bracelet_v2_rudder',

  PART_DOG_PUFFYVEST_V1_PLATFORM = 'item_part_dog_puffyvest_v1_platform',
  PART_DOG_PUFFYVEST_V2_PLATFORM = 'item_part_dog_puffyvest_v2_platform',
  PART_DOG_BAKERSHAT_V1_HELMET = 'item_part_dog_bakershat_v1_helmet',
  PART_DOG_BAKERSHAT_V2_HELMET = 'item_part_dog_bakershat_v2_helmet',
  PART_DOG_SCRUNCHIE_V1_TREADS = 'item_part_dog_scrunchie_v1_treads',
  PART_DOG_SCRUNCHIE_V2_TREADS = 'item_part_dog_scrunchie_v2_treads',
  PART_DOG_BRACELET_V1_RUDDER = 'item_part_dog_bracelet_v1_rudder',
  PART_DOG_BRACELET_V2_RUDDER = 'item_part_dog_bracelet_v2_rudder',

  PART_PIG_PUFFYVEST_V1_PLATFORM = 'item_part_pig_puffyvest_v1_platform',
  PART_PIG_PUFFYVEST_V2_PLATFORM = 'item_part_pig_puffyvest_v2_platform',
  PART_PIG_BAKERSHAT_V1_HELMET = 'item_part_pig_bakershat_v1_helmet',
  PART_PIG_BAKERSHAT_V2_HELMET = 'item_part_pig_bakershat_v2_helmet',
  PART_PIG_SCRUNCHIE_V1_TREADS = 'item_part_pig_scrunchie_v1_treads',
  PART_PIG_SCRUNCHIE_V2_TREADS = 'item_part_pig_scrunchie_v2_treads',
  PART_PIG_BRACELET_V1_RUDDER = 'item_part_pig_bracelet_v1_rudder',
  PART_PIG_BRACELET_V2_RUDDER = 'item_part_pig_bracelet_v2_rudder',

  PART_HORSE_PUFFYVEST_V1_PLATFORM = 'item_part_horse_puffyvest_v1_platform',
  PART_HORSE_PUFFYVEST_V2_PLATFORM = 'item_part_horse_puffyvest_v2_platform',
  PART_HORSE_BAKERSHAT_V1_HELMET = 'item_part_horse_bakershat_v1_helmet',
  PART_HORSE_BAKERSHAT_V2_HELMET = 'item_part_horse_bakershat_v2_helmet',
  PART_HORSE_SCRUNCHIE_V1_TREADS = 'item_part_horse_scrunchie_v1_treads',
  PART_HORSE_SCRUNCHIE_V2_TREADS = 'item_part_horse_scrunchie_v2_treads',
  PART_HORSE_BRACELET_V1_RUDDER = 'item_part_horse_bracelet_v1_rudder',
  PART_HORSE_BRACELET_V2_RUDDER = 'item_part_horse_bracelet_v2_rudder',

  PART_SHEEP_PUFFYVEST_V1_PLATFORM = 'item_part_sheep_puffyvest_v1_platform',
  PART_SHEEP_PUFFYVEST_V2_PLATFORM = 'item_part_sheep_puffyvest_v2_platform',
  PART_SHEEP_BAKERSHAT_V1_HELMET = 'item_part_sheep_bakershat_v1_helmet',
  PART_SHEEP_BAKERSHAT_V2_HELMET = 'item_part_sheep_bakershat_v2_helmet',
  PART_SHEEP_SCRUNCHIE_V1_TREADS = 'item_part_sheep_scrunchie_v1_treads',
  PART_SHEEP_SCRUNCHIE_V2_TREADS = 'item_part_sheep_scrunchie_v2_treads',
  PART_SHEEP_BRACELET_V1_RUDDER = 'item_part_sheep_bracelet_v1_rudder',
  PART_SHEEP_BRACELET_V2_RUDDER = 'item_part_sheep_bracelet_v2_rudder',

  PART_CAT_MAPLELEAVES_V1_HELMET = 'item_part_cat_mapleleaves_v1_helmet',
  PART_CAT_MAPLELEAVES_V2_HELMET = 'item_part_cat_mapleleaves_v2_helmet',
  PART_DOG_MAPLELEAVES_V1_HELMET = 'item_part_dog_mapleleaves_v1_helmet',
  PART_DOG_MAPLELEAVES_V2_HELMET = 'item_part_dog_mapleleaves_v2_helmet',
  PART_PIG_MAPLELEAVES_V1_HELMET = 'item_part_pig_mapleleaves_v1_helmet',
  PART_PIG_MAPLELEAVES_V2_HELMET = 'item_part_pig_mapleleaves_v2_helmet',
  PART_HORSE_MAPLELEAVES_V1_HELMET = 'item_part_horse_mapleleaves_v1_helmet',
  PART_HORSE_MAPLELEAVES_V2_HELMET = 'item_part_horse_mapleleaves_v2_helmet',
  PART_SHEEP_MAPLELEAVES_V1_HELMET = 'item_part_sheep_mapleleaves_v1_helmet',
  PART_SHEEP_MAPLELEAVES_V2_HELMET = 'item_part_sheep_mapleleaves_v2_helmet',

  PART_CAT_TOPHAT_V1_HELMET = 'item_part_cat_tophat_v1_helmet',
  PART_CAT_TOPHAT_V2_HELMET = 'item_part_cat_tophat_v2_helmet',
  PART_DOG_TOPHAT_V1_HELMET = 'item_part_dog_tophat_v1_helmet',
  PART_DOG_TOPHAT_V2_HELMET = 'item_part_dog_tophat_v2_helmet',
  PART_PIG_TOPHAT_V1_HELMET = 'item_part_pig_tophat_v1_helmet',
  PART_PIG_TOPHAT_V2_HELMET = 'item_part_pig_tophat_v2_helmet',
  PART_HORSE_TOPHAT_V1_HELMET = 'item_part_horse_tophat_v1_helmet',
  PART_HORSE_TOPHAT_V2_HELMET = 'item_part_horse_tophat_v2_helmet',
  PART_SHEEP_TOPHAT_V1_HELMET = 'item_part_sheep_tophat_v1_helmet',
  PART_SHEEP_TOPHAT_V2_HELMET = 'item_part_sheep_tophat_v2_helmet',

  PART_CAT_PAPERHAT_V1_HELMET = 'item_part_cat_paperhat_v1_helmet',
  PART_CAT_PAPERHAT_V2_HELMET = 'item_part_cat_paperhat_v2_helmet',
  PART_DOG_PAPERHAT_V1_HELMET = 'item_part_dog_paperhat_v1_helmet',
  PART_DOG_PAPERHAT_V2_HELMET = 'item_part_dog_paperhat_v2_helmet',
  PART_PIG_PAPERHAT_V1_HELMET = 'item_part_pig_paperhat_v1_helmet',
  PART_PIG_PAPERHAT_V2_HELMET = 'item_part_pig_paperhat_v2_helmet',
  PART_HORSE_PAPERHAT_V1_HELMET = 'item_part_horse_paperhat_v1_helmet',
  PART_HORSE_PAPERHAT_V2_HELMET = 'item_part_horse_paperhat_v2_helmet',
  PART_SHEEP_PAPERHAT_V1_HELMET = 'item_part_sheep_paperhat_v1_helmet',
  PART_SHEEP_PAPERHAT_V2_HELMET = 'item_part_sheep_paperhat_v2_helmet',

  PART_CAT_DAISYFLOWER_V1_HELMET = 'item_part_cat_daisyflower_v1_helmet',
  PART_CAT_DAISYFLOWER_V2_HELMET = 'item_part_cat_daisyflower_v2_helmet',
  PART_DOG_DAISYFLOWER_V1_HELMET = 'item_part_dog_daisyflower_v1_helmet',
  PART_DOG_DAISYFLOWER_V2_HELMET = 'item_part_dog_daisyflower_v2_helmet',
  PART_PIG_DAISYFLOWER_V1_HELMET = 'item_part_pig_daisyflower_v1_helmet',
  PART_PIG_DAISYFLOWER_V2_HELMET = 'item_part_pig_daisyflower_v2_helmet',
  PART_HORSE_DAISYFLOWER_V1_HELMET = 'item_part_horse_daisyflower_v1_helmet',
  PART_HORSE_DAISYFLOWER_V2_HELMET = 'item_part_horse_daisyflower_v2_helmet',
  PART_SHEEP_DAISYFLOWER_V1_HELMET = 'item_part_sheep_daisyflower_v1_helmet',
  PART_SHEEP_DAISYFLOWER_V2_HELMET = 'item_part_sheep_daisyflower_v2_helmet',

  PART_CAT_SKIGOGGLES_V1_HELMET = 'item_part_cat_skigoggles_v1_helmet',
  PART_CAT_SKIGOGGLES_V2_HELMET = 'item_part_cat_skigoggles_v2_helmet',
  PART_DOG_SKIGOGGLES_V1_HELMET = 'item_part_dog_skigoggles_v1_helmet',
  PART_DOG_SKIGOGGLES_V2_HELMET = 'item_part_dog_skigoggles_v2_helmet',
  PART_PIG_SKIGOGGLES_V1_HELMET = 'item_part_pig_skigoggles_v1_helmet',
  PART_PIG_SKIGOGGLES_V2_HELMET = 'item_part_pig_skigoggles_v2_helmet',
  PART_HORSE_SKIGOGGLES_V1_HELMET = 'item_part_horse_skigoggles_v1_helmet',
  PART_HORSE_SKIGOGGLES_V2_HELMET = 'item_part_horse_skigoggles_v2_helmet',
  PART_SHEEP_SKIGOGGLES_V1_HELMET = 'item_part_sheep_skigoggles_v1_helmet',
  PART_SHEEP_SKIGOGGLES_V2_HELMET = 'item_part_sheep_skigoggles_v2_helmet',

  PART_CAT_TUTU_V1_PLATFORM = 'item_part_cat_tutu_v1_platform',
  PART_CAT_TUTU_V2_PLATFORM = 'item_part_cat_tutu_v2_platform',
  PART_DOG_TUTU_V1_PLATFORM = 'item_part_dog_tutu_v1_platform',
  PART_DOG_TUTU_V2_PLATFORM = 'item_part_dog_tutu_v2_platform',
  PART_PIG_TUTU_V1_PLATFORM = 'item_part_pig_tutu_v1_platform',
  PART_PIG_TUTU_V2_PLATFORM = 'item_part_pig_tutu_v2_platform',
  PART_HORSE_TUTU_V1_PLATFORM = 'item_part_horse_tutu_v1_platform',
  PART_HORSE_TUTU_V2_PLATFORM = 'item_part_horse_tutu_v2_platform',
  PART_SHEEP_TUTU_V1_PLATFORM = 'item_part_sheep_tutu_v1_platform',
  PART_SHEEP_TUTU_V2_PLATFORM = 'item_part_sheep_tutu_v2_platform'
}

export enum ESwatchItemId {
  // MONO
  SWATCH_SOFT_WHITE = 'item_swatch_softwhite',
  SWATCH_LUNAR_WHITE = 'item_swatch_lunarwhite',
  SWATCH_SOFT_YELLOW = 'item_swatch_softyellow',
  SWATCH_SUNSHINE_YELLOW = 'item_swatch_sunshineyellow',
  SWATCH_SOFT_RED = 'item_swatch_softred',
  SWATCH_RUBY_RED = 'item_swatch_rubyred',
  SWATCH_SOFT_BLACK = 'item_swatch_softblack',
  SWATCH_SHADOW_BLACK = 'item_swatch_shadowblack',
  SWATCH_SOFT_BLUE = 'item_swatch_softblue',
  SWATCH_BLUEBERRY = 'item_swatch_blueberry',
  SWATCH_SOFT_GREEN = 'item_swatch_softgreen',
  SWATCH_FOREST_GREEN = 'item_swatch_forestgreen',
  SWATCH_SOFT_ORANGE = 'item_swatch_softorange',
  SWATCH_SPICE_ORANGE = 'item_swatch_spiceorange',
  SWATCH_SOFT_PINK = 'item_swatch_softpink',
  SWATCH_BUBBLEGUM_PINK = 'item_swatch_bubblegumpink',
  SWATCH_SOFT_LAVENDER = 'item_swatch_softlavender',
  SWATCH_LAVENDER_DREAM = 'item_swatch_lavenderdream',
  SWATCH_SOFT_TEAL = 'item_swatch_softteal',
  SWATCH_TEAL_TREAT = 'item_swatch_tealtreat',
  SWATCH_SUNSET = 'item_swatch_sunset',
  SWATCH_VINTAGE = 'item_swatch_vintage',
  SWATCH_VIOLET = 'item_swatch_violet',
  SWATCH_CORAL = 'item_swatch_coral',
  SWATCH_PEARL = 'item_swatch_pearl',
  SWATCH_SAND_DUNE = 'item_swatch_sand_dune',
  SWATCH_SCHOOLBUS_YELLOW = 'item_swatch_schoolbus_yellow',
  SWATCH_MOONLIGHT_MIST = 'item_swatch_moonlight_mist',
  SWATCH_ARCTIC_BLAST = 'item_swatch_arctic_blast',
  SWATCH_EVERGREEN = 'item_swatch_evergreen',
  SWATCH_FESTIVE_FLARE = 'item_swatch_festive_flare',
  SWATCH_GINGERBREAD = 'item_swatch_gingerbread',
  SWATCH_HOLIDAY_CHEER = 'item_swatch_holiday_cheer',
  SWATCH_JOLLY_RED = 'item_swatch_jolly_red',
  SWATCH_MIDNIGHT_BLUE = 'item_swatch_midnight_blue',
  SWATCH_SNOWFLAKE_ROSE = 'item_swatch_snowflake_rose',

  // DUO
  SWATCH_BLUE_DARK_PURPLE = 'item_swatch_bluedarkpurple',
  SWATCH_BLUE_ORANGE = 'item_swatch_blueorange',
  SWATCH_CITRUS_FUSION = 'item_swatch_citrus_fusion',
  SWATCH_COSMIC_YELLOW = 'item_swatch_cosmic_yellow',
  SWATCH_DARK_ROSE = 'item_swatch_dark_rose',
  SWATCH_EVA_01 = 'item_swatch_eva_01',
  SWATCH_EVA_02 = 'item_swatch_eva_02',
  SWATCH_FOREST = 'item_swatch_forest',
  SWATCH_GLASS_COPPER = 'item_swatch_glass_copper',
  SWATCH_GRAPEFRUIT = 'item_swatch_grapefruit',
  SWATCH_GREEN_CITRUS = 'item_swatch_green_citrus',
  SWATCH_GREEN_BLACK = 'item_swatch_greenblack',
  SWATCH_GREEN_PINK = 'item_swatch_greenpink',
  SWATCH_GREEN_RED = 'item_swatch_greenred',
  SWATCH_GREEN_SILVER = 'item_swatch_greensilver',
  SWATCH_GREEN_WHITE = 'item_swatch_greenwhite',
  SWATCH_GREEN_YELLOW = 'item_swatch_greenyellow',
  SWATCH_LAVENDER_BLACK = 'item_swatch_lavenderblack',
  SWATCH_LAVENDER_PINK = 'item_swatch_lavenderpink',
  SWATCH_ORANGE_BLUE = 'item_swatch_orangeblue',
  SWATCH_ORANGE_PURPLE = 'item_swatch_orangepurple',
  SWATCH_PEACH_BLUE = 'item_swatch_peachblue',
  SWATCH_PINK_BLUE = 'item_swatch_pinkblue',
  SWATCH_RED_BLACK = 'item_swatch_redblack',
  SWATCH_RED_BLUE = 'item_swatch_redblue',
  SWATCH_RED_TEAL = 'item_swatch_redteal',
  SWATCH_SILVER_ORANGE = 'item_swatch_silverorange',
  SWATCH_SUNSET_GREEN = 'item_swatch_sunset_green',
  SWATCH_TACTICAL_OPS = 'item_swatch_tactical_ops',
  SWATCH_TACTICAL_RED = 'item_swatch_tactical_red',
  SWATCH_TACTICAL_YELLOW = 'item_swatch_tactical_yellow',
  SWATCH_TEAL_PINK = 'item_swatch_tealpink',
  SWATCH_ULTRAVIOLET = 'item_swatch_ultraviolet',
  SWATCH_VIBRANT_GRAPEFRUIT = 'item_swatch_vibrant_grapefruit',
  SWATCH_WASP = 'item_swatch_wasp',
  SWATCH_POPPING_APPLE_PENCIL = 'item_swatch_popping_apple_pencil',
  SWATCH_SPOOKY_GREEN = 'item_swatch_spooky_green',

  // TRIO
  SWATCH_ALIEN = 'item_swatch_alien',
  SWATCH_BLACK_ORANGE = 'item_swatch_blackorange',
  SWATCH_BLUE_GRAPEFRUIT = 'item_swatch_blue_grapefruit',
  SWATCH_BLUE_SUNSET_TEAL = 'item_swatch_blue_sunset_teal',
  SWATCH_BREAKFAST = 'item_swatch_breakfast',
  SWATCH_CHAOTIC = 'item_swatch_chaotic',
  SWATCH_COFFEE_BEAN = 'item_swatch_coffee_bean',
  SWATCH_COSMIC_GREENPURPLE = 'item_swatch_cosmic_greenpurple',
  SWATCH_COSMIC_WHITERED = 'item_swatch_cosmic_whitered',
  SWATCH_COTTON_CANDY = 'item_swatch_cotton_candy',
  SWATCH_DREAMWAVE = 'item_swatch_dreamwave',
  SWATCH_GLASS_ORANGE_COSMIC = 'item_swatch_glass_orange_cosmic',
  SWATCH_ICE_BLUEORANGE = 'item_swatch_ice_blueorange',
  SWATCH_LAVENDER_REDWHITE = 'item_swatch_lavenderredwhite',
  SWATCH_LEMON_GRAPE = 'item_swatch_lemon_grape',
  SWATCH_OCEAN_MIST = 'item_swatch_ocean_mist',
  SWATCH_ORANGE_ICE_VIOLET = 'item_swatch_orange_ice_violet',
  SWATCH_PINK_SENSATION = 'item_swatch_pink_sensation',
  SWATCH_RED_BLACK_GREEN = 'item_swatch_redblackgreen',
  SWATCH_SILVER_ORCHID = 'item_swatch_silver_orchid',
  SWATCH_SILVER_REDBLUE = 'item_swatch_silverredblue',
  SWATCH_SNOWY = 'item_swatch_snowy',
  SWATCH_SYNTH_PEACH_WHITE = 'item_swatch_synth_peach_white',
  SWATCH_YELLOW_BLACK_WHITE = 'item_swatch_yellowblackwhite',
  SWATCH_PRIMARY_PRIME = 'item_swatch_primary_prime',
  SWATCH_JACK_ZO_SPARK = 'item_swatch_jack_zo_spark',
  SWATCH_CANDY_CORN = 'item_swatch_candy_corn',
  SWATCH_MYSTIC_PURPLE = 'item_swatch_mystic_purple',

  // LEVEL REWARDS
  SWATCH_LEVEL2_GREY = 'item_swatch_level2grey', // level 02 - Grey
  SWATCH_LEVEL5_RED = 'item_swatch_level5red', // Level 05 - Red
  SWATCH_LEVEL10_VIBRANTRED = 'item_swatch_level10vibrantred', // Level 10 - Vibrant Red
  SWATCH_LEVEL15_PINK = 'item_swatch_level15pink', // Level 15 - Pink
  SWATCH_LEVEL20_VIBRANTPINK = 'item_swatch_level20vibrantpink', // Level 20 - Vibrant Pink
  SWATCH_LEVEL25_ORANGE = 'item_swatch_level25orange', // Level 25 - Orange
  SWATCH_LEVEL30_VIBRANTORANGE = 'item_swatch_level30vibrantorange', // Level 30 - Vibrant Orange
  SWATCH_LEVEL35_YELLOW = 'item_swatch_level35yellow', // Level 35 - Yellow
  SWATCH_LEVEL40_VIBRANTYELLOW = 'item_swatch_level40vibrantyellow', // Level 40 - Vibrant Yellow
  SWATCH_LEVEL45_GREEN = 'item_swatch_level45green', // Level 45 - Green
  SWATCH_LEVEL50_VIBRANTGREEN = 'item_swatch_level50vibrantgreen', // Level 50 - Vibrant Green
  SWATCH_LEVEL55_TEAL = 'item_swatch_level55teal', // Level 55 - Teal
  SWATCH_LEVEL60_VIBRANTTEAL = 'item_swatch_level60vibrantteal', // Level 60 - Vibrant Teal
  SWATCH_LEVEL65_BLUE = 'item_swatch_level65blue', // Level 65 - Blue
  SWATCH_LEVEL70_VIBRANTBLUE = 'item_swatch_level70vibrantblue', // Level 70 - Vibrant Blue
  SWATCH_LEVEL75_PURPLE = 'item_swatch_level75purple', // Level 75 - Purple
  SWATCH_LEVEL80_VIBRANTPURPLE = 'item_swatch_level80vibrantpurple', // Level 80 - Vibrant Purple
  SWATCH_LEVEL85_LAVENDER = 'item_swatch_level85lavender', // Level 85 - Lavender
  SWATCH_LEVEL90_VIBRANTLAVENDER = 'item_swatch_level90vibrantlavender', // Level 90 - Vibrant Lavender
  SWATCH_LEVEL95_BLACK = 'item_swatch_level95black', // Level 95 - Black
  SWATCH_LEVEL100_VIBRANTBLACK = 'item_swatch_level100vibrantblack', // Level 100 - Vibrant Black
  SWATCH_LEVEL1000_LEGENDARYGREEN = 'item_swatch_level1000legendarygreen', // Level 1000 - Legendary Green

  // RETIRED - DO NOT REMOVE
  SWATCH_COSMIC_JET = 'item_swatch_cosmicjet',
  SWATCH_TACTICAL_SWAT = 'item_swatch_tacticalswat',
  SWATCH_CINNAMON_COPPER = 'item_swatch_cinnamoncopper',
  SWATCH_KIWI_GREEN = 'item_swatch_kiwigreen',
  SWATCH_SKY_BLUE = 'item_swatch_skyblue'
}

/**
 * This works for to test against the values only, which for these enums, are not the same as their keys, due to the different casing.
 * We could make an even simpler function to test against the keys, though that should never be necessary?
 * @param key
 * @returns
 */
export const isESwatchItemId = (key: string): key is ESwatchItemId => {
  const stringValues = Object.values(ESwatchItemId) as string[];
  return stringValues.includes(key);
};

export const isEPartItemId = (key: string): key is EPartItemId => {
  const stringValues = Object.values(EPartItemId) as string[];
  return stringValues.includes(key);
};

export const EItemId = { ...EBoostItemId, ...ECurrencyItemId, ...EPartItemId, ...ESwatchItemId, ...ERoleHatItemId };

/**
 *  Enumeration of item ids, to make it easier to ensure consistency across the code base.
 */
export type EItemId = EBoostItemId | ECurrencyItemId | EPartItemId | ESwatchItemId | ERoleHatItemId;

export const isEItemId = (key: string): key is EItemId => {
  const stringValues = Object.values(EItemId) as string[];
  return stringValues.includes(key);
};

export enum EGardenPlantId {
  Strawberry = 'strawberry',
  BellPepper = 'bellpepper',
  Blueberry = 'blueberry',
  Bean = 'bean'
}
